import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import * as fromActions from "./service-direct-cost.actions";
import {map, switchMap} from "rxjs/operators";
import * as fromGraphql from "./service-direct-cost.graphql";
import {Apollo} from "apollo-angular";
import {Store} from "@ngrx/store";
import {AppState} from "../../../reducers";
import {NotificationService} from "../../../../services/notification.service";
import {ResponseCodeService} from "../../../../services/response-code.service";


@Injectable()
export class ServiceDirectCostEffects {

  createServiceDirectCost$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.createServiceDirectCosts),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.CREATE_SERVICE_DIRECT_COST,
        variables: {
          input: action?.input,
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while saving record'),
        map(async ({ data }: any) => {

          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.code == '9000') {
              this.store.dispatch(fromActions.upsertServiceDirectCost({ serviceDirectCost: result?.data }));
              await this.notificationService.successMessage('Created Successfully ');
            } else {
              await this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      );
    })
  ), { dispatch: false });

  updateServiceDirectCost$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.editServiceDirectCosts),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.UPDATE_SERVICE_DIRECT_COST,
        variables: {
          input: action?.input,
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while updating record'),
        map(async ({ data }: any) => {
          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.code == '9000') {
              this.store.dispatch(fromActions.upsertServiceDirectCost({ serviceDirectCost: result?.data }));
              await this.notificationService.successMessage('Updated Successfully ');
            } else {
              await this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      );
    })
  ), { dispatch: false });

  deleteServiceDirectCost$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.removeServiceDirectCosts),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.DELETE_SERVICE_DIRECT_COST,
        variables: {
          costUniqueId: action?.costUniqueId,
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while deleting record'),
        map(async ({ data }: any) => {
          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.code == '9000') {
              this.store.dispatch(fromActions.deleteServiceDirectCost({ id: action.id }));
              await this.notificationService.successMessage('Deleted Successfully');
            } else {
              await this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      );
    })
  ), { dispatch: false });

  getServiceCategories$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.getServiceDirectCosts),
    switchMap((action) => {
      return this.apollo.query({
        query: fromGraphql.GET_SERVICE_DIRECT_COST,
        fetchPolicy: 'network-only',
        variables: {
          billingUniqueId: action.billingUniqueId
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while fetching billing direct cost details'),
        map(({ data }: any ) => {
          if (data) {
            const result: any = Object.values(data)[0]
            result?.response?.status ? this.store.dispatch(fromActions.loadServiceDirectCosts({ serviceDirectCosts: result?.data })) : []
          }
        })
      );
    })
  ), { dispatch: false });

  citizenGetInstitutionServiceDirectCostSchemes$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.citizenGetInstitutionServiceDirectCostSchemes),
    switchMap((action) => {
      return this.apollo.query({
        query: fromGraphql.CITIZEN_GET_INSTITUTION_SERVICE_DIRECT_COST_SCHEMES,
        fetchPolicy: 'network-only',
        variables: {
          billingUniqueId: action.billingUniqueId
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while fetching billing direct cost details'),
        map(({ data }: any ) => {
          if (data) {
            const result: any = Object.values(data)[0]
            result?.response?.status ? this.store.dispatch(fromActions.loadServiceDirectCosts({ serviceDirectCosts: result?.data })) : []
          }
        })
      );
    })
  ), { dispatch: false });

  constructor(
    private actions$: Actions,
    private apollo: Apollo,
    private store: Store<AppState>,
    private notificationService: NotificationService,
    private responseCodesService: ResponseCodeService
  ) {}
}
